import React from 'react'

import { Navigate, Route, Routes } from 'react-router'
import { Spinner } from 'src/components/__legacy__/spinner/spinner'
import { RedirectLogin } from 'src/components/RedirectLogin/RedirectLogin'
import { AuthenticatedAccountProvider } from 'src/features/auth/context'
import { useAuth } from 'src/features/auth/hooks'
import { SelectTrialContainer } from 'src/legacy_modules/dashboard/select-trial/select-trial-container'

import { routes } from './routes'
import { CompleteDocuSignEditContainer } from './trial/detail/e-consent/icf-document/icf-document/complete-docusign-edit/complete-docusign-edit-container'
import { VideoViewerContainer } from './trial/detail/e-consent/icf-document/icf-document/video-viewer/video-viewer-container'
import { TrialContent } from './trial/trial'

export const DashboardScreen: React.FC = () => {
  const authState = useAuth()

  if (authState.state === 'Challenging') {
    return <Spinner />
  }

  if (authState.state === 'Failed') {
    return <RedirectLogin />
  }

  if (!authState.account.hasSelectedTrial) {
    return <SelectTrialContainer redirectWithPathSelection />
  }

  return (
    <AuthenticatedAccountProvider account={authState.account}>
      <Router />
    </AuthenticatedAccountProvider>
  )
}

const Router = () => {
  return (
    <Routes>
      {/* 動画ビューア */}
      <Route
        path={`${routes.icfDocumentRevisionVideoStream}`}
        element={<VideoViewerContainer />}
      />
      {/* eConsentでDocuSign編集が完了したリダイレクト先 */}{' '}
      <Route
        path={`${routes.completeDocuSign}`}
        element={<CompleteDocuSignEditContainer />}
      />
      <Route path={`${routes.trials}/*`} element={<TrialContent />} />
      <Route path="*" element={<Navigate replace to={`${routes.trials}`} />} />
    </Routes>
  )
}
